import {
  coverageRSForcedAtXYearsStates,
  extendedCoverageRSByRoofMaterialStateExclusions,
  extendedCoverageRSLimitsCW,
  extendedCoverageRSByRoofMaterialNonCWStatesList,
  extendedCoverageRSLimitsNonCW,
  noShowRoofSurfacesExtendedUnderXYearsStates
} from '../roof-constants';

import { mapExpandedToSimpleRoofType, SimpleRoofTypes } from './roof-material-mappings';

import { getTXRoofSurfacesExtended, getOKRoofSurfacesExtended } from './tx-roof-rules';

export type GetRoofAgeLimit = {
  roofType: string;
  state: string;
  deductibleWindHail?: number;
  roofAge?: number;
};

export function getRoofAgeLimit({ roofType, state, deductibleWindHail, roofAge }: GetRoofAgeLimit) {
  if (state === 'TX' && roofAge && deductibleWindHail) {
    return getTXRoofSurfacesExtended(roofAge, deductibleWindHail).roofAgeLimit;
  }

  if (state === 'OK' && roofAge && deductibleWindHail) {
    return getOKRoofSurfacesExtended(roofAge, deductibleWindHail).roofAgeLimit;
  }

  // states where coverageRSExtended is determined by roofAge only
  if (noShowRoofSurfacesExtendedUnderXYearsStates[state as keyof typeof noShowRoofSurfacesExtendedUnderXYearsStates]) {
    return noShowRoofSurfacesExtendedUnderXYearsStates[
      state as keyof typeof noShowRoofSurfacesExtendedUnderXYearsStates
    ];
  }

  // use the simpler roof types
  const simpleRoofType: SimpleRoofTypes =
    roofType?.length > 1 ? (mapExpandedToSimpleRoofType(roofType) as SimpleRoofTypes) : (roofType as SimpleRoofTypes);

  // Check eligibility for extended coverage based on state and roof type
  const isStateEligibleForExtendedCoverage = !extendedCoverageRSByRoofMaterialStateExclusions.includes(state);
  const hasRoofTypeSpecificLimits = Object.keys(extendedCoverageRSLimitsCW).includes(simpleRoofType);

  // Default state limits if not eligible for extended coverage
  if (
    (!isStateEligibleForExtendedCoverage || !hasRoofTypeSpecificLimits) &&
    coverageRSForcedAtXYearsStates[state as keyof typeof coverageRSForcedAtXYearsStates]
  ) {
    return coverageRSForcedAtXYearsStates[state as keyof typeof coverageRSForcedAtXYearsStates] || 15;
  }

  // Apply specific limits based on CW or non-CW state
  const isNonCWState = extendedCoverageRSByRoofMaterialNonCWStatesList.includes(state);
  if (isNonCWState) {
    return extendedCoverageRSLimitsNonCW[simpleRoofType as SimpleRoofTypes] || 10;
  }

  return extendedCoverageRSLimitsCW[simpleRoofType as SimpleRoofTypes] || 15;
}
